import { useAsyncActionHandler } from "@umami/state";
import { getEnv } from "@umami/utils";
const SAPLING_SERVICE_BACKEND_URL = getEnv("VITE_SAPLING_SERVICE_BACKEND_URL");
type UseSubmitToRelayerProps = {
  transaction: string;
  // `null` means the caller's network doesn't have a Sapling relayer backend
  // slot — submit() throws instead of silently misrouting to another network.
  network: "shadownet" | "mainnet" | null;
};

export const useSubmitToRelayer = ({ transaction: tx, network }: UseSubmitToRelayerProps) => {
  const { isLoading, handleAsyncAction } = useAsyncActionHandler();

  const submitToRelayer = () =>
    handleAsyncAction(async () => {
      if (network === null) {
        throw new Error("Shielded submission is not supported on the currently selected network.");
      }

      try {
        const response = await fetch(`${SAPLING_SERVICE_BACKEND_URL}/submit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tx,
            network,
          }),
        });
        const data = await response.json();

        return data;
      } catch (error) {
        console.error("Error submitting transaction to relayer:", error);
        throw error;
      }
    });

  return {
    submitToRelayer,
    isLoading,
  };
};
